import { Component, OnInit } from '@angular/core';
import { InfoHelper } from '../../helpers/info.helper';
import { SnackbarService } from '../snackbar/snackbar.service';
import { DefaultConfigComponent } from '../../inherit/default-config.component';
import { NavStorageService } from 'src/app/core/nav-storage/services/nav-storage.service';
import { Router } from '@angular/router';
import { SendInfoComponentService } from 'src/app/core/services/local/send-info.component.service';
import { MatDialog } from '@angular/material/dialog';
import { ProfileUserDialog } from 'src/app/inside/configuration/user/components/profile-user/profile-user-dialog';
import { TranslateHelper } from '../../helpers/translate.helper';

@Component({
  selector: 'app-user-sidenav',
  templateUrl: './user-sidenav.component.html',
  styleUrls: ['./user-sidenav.component.scss']
})
export class UserSidenavComponent extends DefaultConfigComponent<{}> implements OnInit {  
  constructor(snackBar: SnackbarService, navStorageService: NavStorageService, infoHelper : InfoHelper, nav: Router, private executeInfo: SendInfoComponentService, public dialog: MatDialog) {
		super(snackBar, infoHelper, navStorageService, nav, {}, executeInfo);
    this.loadInfo();
  }
  
  ngOnInit(): void {
    this.listTraduction = TranslateHelper.getTranslation('home');
		this.executeInfo.sendObjectAction.subscribe(data => {
      if (data.isExecuted && data.key === "traduction") {
        this.listTraduction = TranslateHelper.getTranslation('home');
      }
    });
  }

  onViewProfile(){    
    this.dialog.open(ProfileUserDialog, {
      width: 'auto',
      height: 'auto'
    }); 
  }
}
